import React from 'react'
import { isEmpty } from 'lodash'

import { Loader } from '../../../../../components'
import Status from '../IssueStatus'
import { getIssueReportDate } from '../../../../../helpers'
import { REPORT } from '../../../../../helpers/constants'

import Style from './style'

const IssueManagementListView = (props) => {
  const {
    language,
    issues,
    isLoading,
    colorTheme,
  } = props

  const IssueImages = ({ images }) => {
    return images.map(({ id, thumbnail }) => (
        <div
          key={id}
          className='bg-image'
        >
          <img
            className='issue-image-item'
            src={`${process.env.REACT_APP_BASE_API_URL}rest/V2/issue/image/${thumbnail}`}
            alt='issue'
          />
        </div>
      )
    )
  }

  const IssueItem = ({ language, item }) => {
    const { id, itemName, detail, images } = item

    const key = id
    const header = `${REPORT.ISSUE[language]} #${key}`
    const name = itemName === '-' ? REPORT.OTHER[language] : itemName
    const description = detail

    return (
      <div
        key={key}
        className='issue-item'
      >
        <div className='issue-item-header-layout'>
          <div className='issue-item-header-status'>
            <div className='issue-item-header'>{header}</div>
            <Status status={item.status} language={language} />
          </div>
  
          <div className='issue-item-date'>{getIssueReportDate(item.createdAt, language)}</div>
        </div>
  
        <div className='issue-orders-item'>{name}</div>
        <div className='issue-description'>{description}</div>
        
        <div className='issue-images'>
          {!isEmpty(images) && <IssueImages images={images} />}
        </div>
      </div>
    )
  }

  return (
    <Style>
      {isLoading && <Loader colorTheme={colorTheme}/>}

      {isEmpty(issues) && !isLoading
        ? <div className='issue-not-found'>{REPORT.NOT_FOUND_ISSUE[language]}</div>
        : issues.map((item) => (
          <IssueItem
            language={language}
            item={item}
          />
          )
        )
      }
    </Style>
  )
}

export default IssueManagementListView
